import {TranslateLoader} from '@ngx-translate/core';

import { HttpClient } from '@angular/common/http';
import { Observable , forkJoin} from 'rxjs';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
export class CustomTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private prefix: string = '/assets/i18n/', private suffix: string = '.json') {}
  public getTranslation(lang: string): Observable<any> {
    const en$ = this.http.get(`${this.prefix}en${this.suffix}`).pipe(catchError(() => of({})));
    const lang$ = lang === 'en'
      ? of({})
      : this.http.get(`${this.prefix}${lang}${this.suffix}`).pipe(catchError(() => of({})));

    return forkJoin([en$, lang$]).pipe(
      map(([en, langObj]) => ({ ...en, ...langObj }))
    );
  }
}